module.exports = __webpack_public_path__ + "media/components/Hero/hero-fa73986278d68a0c95aa20dc9dd62e5d.jpg";